var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudUpBlue50(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "14px",
    viewBox: "0 0 22 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "24x24/Cloud_Up") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M11,5 C14.143,5 16.846,7.085 17.712,10.005 C20.099,10.115 22,12.086 22,14.5 C22,16.985 19.985,19 17.5,19 C16.948,19 16.5,18.552 16.5,18 C16.5,17.448 16.948,17 17.5,17 C18.881,17 20,15.881 20,14.5 C20,13.119 18.881,12 17.5,12 C17.361,12 17.223,12.011 17.088,12.034 C16.541,12.124 16.025,11.752 15.937,11.205 C15.553,8.797 13.466,7 11,7 C9.19,7 7.551,7.969 6.664,9.509 C6.473,9.839 6.112,10.032 5.732,10.008 C5.655,10.003 5.578,10 5.5,10 C3.567,10 2,11.567 2,13.5 C2,15.433 3.567,17 5.5,17 C6.052,17 6.5,17.448 6.5,18 C6.5,18.552 6.052,19 5.5,19 C2.462,19 0,16.538 0,13.5 C0,10.546 2.329,8.136 5.251,8.006 C6.543,6.147 8.672,5 11,5 Z M12,13.414 L12,18.003 C12,18.554 11.556,19 11,19 C10.448,19 10,18.553 10,18.003 L10,13.414 L8.707,14.707 C8.317,15.098 7.683,15.098 7.293,14.707 C6.902,14.317 6.902,13.683 7.293,13.293 L10.293,10.293 C10.683,9.902 11.317,9.902 11.707,10.293 L14.707,13.293 C15.098,13.683 15.098,14.317 14.707,14.707 C14.317,15.098 13.683,15.098 13.293,14.707 L12,13.414 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "01-KnowledgeBase",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "01.6-\\u2014-KnowledgeBase-\\xB7-Add-Resources",
    transform: "translate(-714.000000, -418.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Settings-screen",
    transform: "translate(666.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(24.000000, 133.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "24x24/Cloud_Up",
    transform: "translate(24.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "icon",
    fill: "#0067DF",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudUpBlue50);
export default __webpack_public_path__ + "static/media/Cloud_Up_Blue_50.b27a0543b19b03dd0977c9542b6a8a8c.svg";
export { ForwardRef as ReactComponent };